/**
 * Homepage: fade sections in when ~40% visible.
 * No scroll listeners.
 * Skips first MainContent section (hero).
 */
(function () {
  if (!document.body.classList.contains('template--index')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var main = document.getElementById('MainContent');
  if (!main) return;
  var sections = main.querySelectorAll(':scope > .shopify-section');
  if (sections.length < 2) return;
  var REVEAL_CLASS = 'home-reveal-section';
  var VISIBLE_CLASS = 'home-reveal-section--visible';
  var THRESHOLD = 0.4;
  var HERO_SECTION_ID = 'shopify-section-home_hero_split';
  var observedSections = [];
  for (var j = 0; j < sections.length; j++) {
    var section = sections[j];
    if (section.id === HERO_SECTION_ID || (!document.getElementById(HERO_SECTION_ID) && j === 0)) {
      continue;
    }
    observedSections.push(section);
  }
  if (!observedSections.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < THRESHOLD) {
          return;
        }
        entry.target.classList.add(VISIBLE_CLASS);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: THRESHOLD
    }
  );
  observedSections.forEach(function (section) {
    observer.observe(section);
  });
})();